const formatAmount = (amount, lang = 'bg-BG', currency = 'BGN') => new Intl.NumberFormat(lang, { style: 'currency', currency }).format(amount ?? 0);

export default formatAmount;